import styled from "styled-components";
import { getDirection } from "../../../../themes/common";
import { theme } from "../theme/toyotaTheme";

export const Tags = styled.div``;

export const Tag = styled.div.attrs(() => ({
    className: "t-milli-text",
}))`
    display: inline-block;
    padding: 3px 11px;
    color: ${theme.colors.grey7};
    &:first-child {
        padding-${getDirection("left")}: 0;
    }
    &:last-child {
        padding-${getDirection("right")}: 0;
    }
`;
